import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { finalize } from "rxjs/operators";
import { AuthService } from "../../../services/auth.service";
import { SnackbarService } from "../../../services/snackbar.service";

import { environment } from "../../../../environments/environment";
import { LoaderService } from "../../../services/loader.service";

@Component({
  selector: "app-esqueci-senha",
  templateUrl: "./esqueci-senha.component.html",
  styleUrls: ["./esqueci-senha.component.css"],
})
export class EsqueciSenhaComponent {
  isSending = false;
  isEmailSent = false;

  // FORM CONTROLS
  username = new FormControl("", [Validators.required]);

  // FORM GROUPS
  esqueciSenha = new FormGroup({
    username: this.username,
  });

  logoPath = `assets/img/${environment.name}/logo.png`;

  constructor(
    private authService: AuthService,
    private snackBarService: SnackbarService,
    private loaderService: LoaderService
  ) {}

  send() {
    this.loaderService.addLoader();
    this.username.markAsDirty();

    if (!this.esqueciSenha.valid) {
      return;
    }

    this.isSending = true;

    this.authService
      .passwordForgot(this.username.value)
      .pipe(
        finalize(() => {
          this.isSending = false;
          this.loaderService.removeLoader();
        })
      )
      .subscribe((result) => {
        if (result) {
          this.isEmailSent = true;
          return;
        }

        this.snackBarService.open("Usuário inválido", "OK");
      });
  }

  isSent() {
    return this.isEmailSent;
  }
}
